import Logo from '../../assests/navLogo.png'
import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
} from '@headlessui/react';
import {
  TagIcon,
  Bars3Icon,
  SquaresPlusIcon,
  UserGroupIcon,
  WrenchScrewdriverIcon,
  TicketIcon,
  XMarkIcon,
  UserIcon
} from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom';
import { useAuth } from "../../context/AuthContext";

const products = [
  { name: 'Rent', description: 'Borrow or lend items with ease', href: 'rent', icon: SquaresPlusIcon },
  { name: 'Sell', description: 'Reach buyers directly', href: 'sell', icon: TagIcon },
  { name: 'Services', description: 'Offer and manage services seamlessly', href: 'services', icon: WrenchScrewdriverIcon },
  // { name: 'Ticketing', description: 'Coming Soon', href: 'ticketing', icon: TicketIcon },
  { name: 'Communities', description: 'Bring people together, share ideas, and grow connections', href: 'SGLoop', icon: UserGroupIcon },
]

function NavBar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout } = useAuth();

  useEffect(() => {
    const header = document.getElementById("header");
    const navcontent = document.getElementById("nav-content");
    const navaction = document.getElementById("navAction");
    const navMenu = document.getElementById("nav-toggle");
    const toToggle = document.querySelectorAll(".toggleColour");

    const applyScrolledStyle = () => {
      header?.classList.add("bg-white");
      navaction?.classList.remove("bg-white");
      navaction?.classList.add("gradient");
      navaction?.classList.remove("text-gray-800");
      navaction?.classList.add("text-white");

      toToggle.forEach((el) => {
        el.classList.add("text-gray-800");
        el.classList.remove("text-white");
      });

      header?.classList.add("shadow");
      navcontent?.classList.remove("bg-gray-100");
      navcontent?.classList.add("bg-white");
    };

    const resetStyle = () => {
      header?.classList.remove("bg-white");
      navaction?.classList.remove("gradient");
      navaction?.classList.add("bg-white");
      navaction?.classList.remove("text-white");
      navaction?.classList.add("text-gray-800");

      toToggle.forEach((el) => {
        el.classList.add("text-white");
        el.classList.remove("text-gray-800");
      });

      header?.classList.remove("shadow");
      navcontent?.classList.remove("bg-white");
      navcontent?.classList.add("bg-gray-100");
    };

    const handleScroll = () => {
      const scrollpos = window.scrollY;
      const isHomePage = window.location.pathname === "/";

      if (!isHomePage || scrollpos > 10) {
        applyScrolledStyle();
      } else {
        resetStyle();
      }
    };

    const handleClick = (e) => {
      const target = e.target;

      if (!checkParent(target, navcontent)) {
        if (checkParent(target, navMenu)) {
          navcontent?.classList.toggle("hidden");
        } else {
          navcontent?.classList.add("hidden");
        }
      }
    };

    const checkParent = (t, elm) => {
      while (t && t.parentNode) {
        if (t === elm) return true;
        t = t.parentNode;
      }
      return false;
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("click", handleClick);

    handleScroll(); // Initial check

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <nav id="header" className="fixed w-full z-30 top-0 text-white">
      <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8">
        {/* Logo */}
        <div className="flex lg:flex-1">
          <a href="/" className="-m-1.5 p-1.5">
            <span className="sr-only">Nextloop</span>
            <img alt="Logo" src={Logo} className="h-8 w-auto" />
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
        </div>

        {/* Desktop Nav Links */}
        <PopoverGroup className="hidden lg:flex lg:gap-x-12">
          <Popover className="relative">
            <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
              Nextloop App
              <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
            </PopoverButton>

            <PopoverPanel
              transition
              className="absolute top-full -left-8 z-50 mt-3 w-screen max-w-md overflow-hidden 
              rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5 transition"
            >
              <div className="p-4">
                {products.map((item) => (
                  <div
                    key={item.name}
                    className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                  >
                    <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                      <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                    </div>
                    <div className="flex-auto">
                      <Link to={`/${item.href}`} className="block font-semibold text-gray-900">
                        {item.name}
                        <span className="absolute inset-0" />
                      </Link>
                      <p className="mt-1 text-gray-600">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </PopoverPanel>
          </Popover>

          <Link to="/services?nextloop" className="text-sm/6 font-semibold text-gray-900">
            Nextloop Services
          </Link>

          <Link to="/spotlight/gateway" className="text-sm/6 font-semibold text-gray-900">
            Nextloop Gateway
          </Link>
        </PopoverGroup>

        {/* User Section */}
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
  {user ? (
    <Popover className="relative">
      <PopoverButton className="flex items-center gap-x-2 rounded-full p-2 hover:bg-gray-100">
        <UserIcon className="h-6 w-6 text-gray-700" />
        <ChevronDownIcon className="h-4 w-4 text-gray-500" />
      </PopoverButton>

      <PopoverPanel
        className="absolute right-0 mt-2 w-40 rounded-md bg-white shadow-lg ring-1 ring-gray-900/5"
      >
        <div className="py-1">
          <Link
            to="/profile"
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            Profile
          </Link>
          <button
            onClick={logout}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            Log out
          </button>
        </div>
      </PopoverPanel>
    </Popover>
  ) : (
    <Link to="/login" className="text-sm font-semibold text-gray-900">
      Log in <span aria-hidden="true">&rarr;</span>
    </Link>
  )}
</div>
      </nav>

      {/* Mobile Menu */}
      <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
        <div className="fixed inset-0 z-50" />
        <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm">
          <div className="flex items-center justify-between">
            <a href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Nextloop</span>
              <img alt="Logo" src={Logo} className="h-8 w-auto" />
            </a>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="size-6" />
            </button>
          </div>

          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <Disclosure as="div" className="-mx-3">
                  <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base font-semibold text-gray-900 hover:bg-gray-50">
                    Nextloop App
                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                  </DisclosureButton>
                  <DisclosurePanel className="mt-2 space-y-2">
                    {products.map((item) => (
                      <Link key={item.name} to={`/${item.href}`}>
                        <DisclosureButton
                          as="a"
                          className="block rounded-lg py-2 pr-3 pl-6 text-sm font-semibold text-gray-900 hover:bg-gray-50"
                        >
                          {item.name}
                        </DisclosureButton>
                      </Link>
                    ))}
                  </DisclosurePanel>
                </Disclosure>
                <Link
                  to="/services?nextloop"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                >
                  Nextloop Services
                </Link>
                <Link
                  to="/spotlight/gateway"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                >
                  Nextloop Gateway
                </Link>
              </div>

              <div className="py-6">
                {user ? (
                  <div className="flex flex-col space-y-2">
                    <Link
                      to="/profile"
                      className="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                    >
                      Profile
                    </Link>
                    <button
                      onClick={logout}
                      className="text-left rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                    >
                      Log out
                    </button>
                  </div>
                ) : (
                  <Link
                    to="/login"
                    className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold text-gray-900 hover:bg-gray-50"
                  >
                    Log in
                  </Link>
                )}
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </nav>
  );
}

export default NavBar;
